import _get from 'lodash.get';
import ApiClient from '../../common/utils/apiClient';
import updateAuthToken from '../../common/utils/updateAuthToken';
import { setLoginCookie, deleteLoginCookie } from '../utils/loginCookies';

export const actionTypes = {
    SET_AUTH_INFO: 'SET_AUTH_INFO',
    GET_LOGGEDIN_BOOKMAKERS: 'GET_LOGGEDIN_BOOKMAKERS',
    SET_LOGGEDIN_BOOKMAKERS: 'SET_LOGGEDIN_BOOKMAKERS',
    SET_LOGIN: 'SET_LOGIN',
    SET_LOGIN_SUCCESS: 'SET_LOGIN_SUCCESS',
    SET_LOGIN_FAILURE: 'SET_LOGIN_FAILURE',
    CLEAR_JUST_LOGGEDIN: 'CLEAR_JUST_LOGGEDIN',
    SET_LOGGEDOUT: 'SET_LOGGEDOUT',
    POPULATE_BOOKMAKERS_WITH_DATASOURCE: 'POPULATE_BOOKMAKERS_WITH_DATASOURCE',
    USER_INFO_REQUESTING: 'USER_INFO_REQUESTING',
    SET_USER_INFO: 'SET_USER_INFO',
    SET_USER_INFO_ERROR: 'SET_USER_INFO_ERROR',
};

const getLoggedInBookmakers = () => ({
    type: actionTypes.GET_LOGGEDIN_BOOKMAKERS,
});

const setLoggedInBookmakers = feeds => ({
    type: actionTypes.SET_LOGGEDIN_BOOKMAKERS,
    feeds,
});

export const setLogIn = feed => ({
    type: actionTypes.SET_LOGIN,
    feed,
});

export const setLogInSuccess = feed => ({
    type: actionTypes.SET_LOGIN_SUCCESS,
    feed,
});
export const setLogInFailure = (feed, err) => ({
    type: actionTypes.SET_LOGIN_FAILURE,
    feed,
    err,
});

export const clearJustLoggedInBookmaker = () => ({
    type: actionTypes.CLEAR_JUST_LOGGEDIN,
});

export const setLoggedOut = feed => ({
    type: actionTypes.SET_LOGGEDOUT,
    feed,
});

export const setAuthInfo = (feed, info) => ({
    type: actionTypes.SET_AUTH_INFO,
    feed,
    info,
});

const setUserInfoRequesting = feed => ({
    type: actionTypes.USER_INFO_REQUESTING,
    feed,
});

const setUserInfo = (feed, data) => ({
    type: actionTypes.SET_USER_INFO,
    feed,
    data,
});

const setUserInfoError = (feed, error) => ({
    type: actionTypes.SET_USER_INFO_ERROR,
    feed,
    error,
});

/**
 * @param  {String} bookie e.g. 'ladbrokes'
 * @param  {String} feed   e.g. 'LADB'
 */
export const getUserInfo = (bookie, feed) => (dispatch) => {
    dispatch(setUserInfoRequesting(feed))

    const CURRENCY_TO_SIGN_DICTIONARY = {
        GBP: "£",
        EUR: "€",
        USD: "$",
    };

    return ApiClient.getUserInfo(bookie)
        .then((res) => {
            updateAuthToken(res.headers);
            if (
                !res.data ||
                !res.data.data ||
                !res.data.data[0] ||
                !res.data.data[0].attributes ||
                res.status !== 200
            ) {
                return Promise.reject(res);
            }
            return res.data.data[0].attributes;
        })
        .then((data) => {
            const userInfo = {
                userName: data.username,
                balance: parseFloat(data.account_balance.split(',').join('')),
                currency: data.account_currency,
                currencySign:
                    CURRENCY_TO_SIGN_DICTIONARY[data.account_currency],
                freeBetBalance: data.free_bet_balance,
                freeBets: data.free_bets,
            }
            dispatch(setUserInfo(feed, userInfo))
        })
        .catch((errorInfo) => {
            const data = _get(errorInfo, 'response.data', {})
            dispatch(setUserInfoError(feed, data.data || data))
            return Promise.reject(errorInfo)
        })
}

const getUserBookmakerInfo = () => {
    const bookmakerInfoString = window.localStorage.getItem('userAccountsInfo');

    if (!bookmakerInfoString) return null;

    const bookmakersInfo = JSON.parse(bookmakerInfoString);

    return bookmakersInfo;
}

const setBookmakersInfoLoginStatus = (bookmakerApiNames) => {
    const bookmakersInfo = getUserBookmakerInfo();
    if (!bookmakersInfo) return;

    Object.keys(bookmakersInfo).forEach((key) => {
        const bookmakerInfo = bookmakersInfo[key];
        const isLoggedIn = bookmakerApiNames.indexOf(bookmakerInfo.apiName) !== -1;
        bookmakerInfo.isLoggedIn = isLoggedIn;
    });

    window.localStorage.setItem('userAccountsInfo', JSON.stringify(bookmakersInfo));
}

export const initializeLoggedInBookmakers = bookmakers => (dispatch) => {
    dispatch(getLoggedInBookmakers());

    return ApiClient.getCustomerStatus()
        .then((res) => {
            updateAuthToken(res.headers);
            if (
                !res.data ||
                !res.data.data ||
                res.status !== 200
            ) {
                return Promise.reject(res);
            }
            const loggedInBookmakers = res.data.data.filter(
                item => item.attributes && item.attributes.active_session,
            );
            const bookmakerApiNames = loggedInBookmakers.map(item => item.id);
            const fullFeeds = [];

            setBookmakersInfoLoginStatus(bookmakerApiNames);

            bookmakers.forEach((bookmaker) => {
                if (bookmakerApiNames.find(item => item === bookmaker.apiName)) {
                    fullFeeds.push({
                        feed: bookmaker.feed,
                        apiName: bookmaker.apiName,
                    })
                    setLoginCookie(
                        bookmaker.cookieName,
                        bookmaker.loginDuration,
                    );
                } else {
                    deleteLoginCookie(bookmaker.cookieName);
                }
            })

            const partialFeeds = fullFeeds.map(item => item.feed)

            dispatch(setLoggedInBookmakers(partialFeeds))

            return fullFeeds;
        })
        .then((data) => {
            data.map(({ feed, apiName }) => (
                dispatch(getUserInfo(apiName, feed))
            ))
        })
        .catch(errorInfo => Promise.reject(errorInfo))
}



// WEBPACK FOOTER //
// /src/js/common/bookmakersList/bookmakersList.actions.js